/*********************************************************************************
 * Copyright (C) 2025 VECROS Technologies Pvt. Ltd.
 * <legal@vecros.com>
 * This file is part of VECROS CLOUD SOFTWARE SERVICES maintained and developed by VECROS TECHNOLOGIES PRIVATE LIMITED.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 **********************************************************************************/

import client from "./client";

/**
 * Organisations the signed-in user belongs to, and which one this session is
 * currently acting as. Membership lives server-side; this is a read of it, and
 * the API re-checks membership on every org-scoped query regardless.
 */
export const listOrganisations = async () => {
  const { data } = await client.get("/auth/organisations");
  return {
    organisations: data.organisations || [],
    activeOrganisationId: data.active_organisation_id ?? null,
  };
};

/**
 * Switch which organisation the session acts as. Returns 403 if the user isn't
 * a member — the client's choice is a selection, never a grant.
 */
export const setActiveOrganisation = async (organisationId) => {
  const { data } = await client.post("/auth/organisations/active", {
    organisation_id: organisationId,
  });
  return data.active_organisation_id;
};
